import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Entity} from 'app/pages/product/product.model';
import {SystemService} from 'app/services/system.service';
import {User} from './user.model';
import {UserService} from './user.service';
import {AttributeValue} from '../attributes/attributes.model';
import {AttributesComponent} from '../attributes/attributes.component';
import {ProductService} from '../../pages/product/product.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FuseConfirmDialogComponent} from '../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss'],
    encapsulation: ViewEncapsulation.None,

})
export class UserFormComponent implements OnInit {


    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    public contactForm: FormGroup;
    public action: string;
    public user: User;
    private confirmP: string;
    format: any = { add: 'Agregar', remove: 'Quitar', all: 'Todos',
        none: 'Niguno', direction: 'left-to-right', draggable: false, locale: undefined };
    roles: Entity[];
    teams: Entity[];

    @Input()
    public title: string;

    @Output()
    entityChanged: EventEmitter<any> = new EventEmitter();
    attributes: AttributeValue[];

    @ViewChild('attributesComp')
    attributesComp: AttributesComponent;


    constructor(private _formBuilder: FormBuilder,
                private userService: UserService,
                public _systemService: SystemService,
                public _projectService: ProductService,
                private _matSnackBar: MatSnackBar,
                public _matDialog: MatDialog,
                public translate: TranslateService) {
        // this.user = new User();
    }


    ngOnInit(): void {
        // this.contactForm = this.createUserForm();
        // this.users = this._systemService.users;
        this.translate.use(this._systemService.visibility.language);
        this.roles = this._systemService.roles;
        this.teams = this._systemService.teams;

    }

    guardarUser(): void{
        const theUser: any = new User(this.contactForm.getRawValue());
        theUser.attributes = this.attributes;
        theUser.teams = this.user.teams;
        theUser.roles = [];

        if (this.user.roles){
            for (const role of this.user.roles) {
                const theRole: any = new Entity(role);
                theRole.type = null;
                theUser.roles.push({id: role.id, name: role.name});
            }
        }

        this.userService.guardarUser(theUser).subscribe(
            resp => {
                this._matSnackBar.open('Usuario guardado', 'OK', {
                    verticalPosition: 'top',
                    duration        : 4000
                });
                this.getAttributes(resp);
                this.entityChanged.emit(resp);
            }
        );

    }

    deleteUser(): void{
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = '¿Estás seguro que querés borrar el usuario "' + this.user.name + '"?';

        this.confirmDialogRef.afterClosed()
            .subscribe(result => {
                if ( result )
                {
                    this.userService.deleteUser(this.user).subscribe(
                        resp => {
                            this._matSnackBar.open('Usuario borrado', 'OK', {
                                verticalPosition: 'top',
                                duration        : 4000
                            });

                            this.entityChanged.emit(this.user.id);
                        }
                    );
                }
                this.confirmDialogRef = null;
            });
    }

    selected(entity: Entity): void{
        if (!entity){
            this.user = null;
        }else {
            if (entity.id > 0) {
                this.userService.getUser(entity.id)
                    .subscribe(
                        resp => {
                            this.user = new User(resp);
                            this.contactForm = this.createUserForm();
                            this.attributes = [];
                            this.getAttributes(entity);
                            this.ngOnInit();
                        }
                    );
            } else {
                this.user = new User(entity);
                this.contactForm = this.createUserForm();
                this.attributes = [];
                this.ngOnInit();
            }
        }

    }


    private getAttributes(entity: Entity): void {
        this._projectService.getAttributes('User', entity.id + '').subscribe(
            respAttributes => {
                // this.attributes = [];
                // respAttributes.forEach(value => {
                //     const attValue: AttributeValue = new AttributeValue(value);
                //     this.attributes.push(attValue);
                // });
                respAttributes.sort((a, b) => a.name.localeCompare(b.name));
                this.attributes = respAttributes;
                if (this.attributes) {
                    this.attributesComp.ngOnInit();
                }
                // this.ngOnInit();
            }
        );
    }

    createUserForm(): FormGroup {
        return this._formBuilder.group({
            id                      : [this.user.id],
            name                    : [this.user.name],
            description             : [this.user.description],
            initials                : [this.user.initials],
            login                   : [this.user.login],
            password                : [this.user.password],
            confirmP                : [this.confirmP],
            mail                    : [this.user.mail],
            workingHoursPerDay      : [this.user.workingHoursPerDay],
            hourIncome              : [this.user.hourIncome],
            externalId              : [this.user.externalId],
            enabled                 : [this.user.enabled],
            enableRecordingHours    : [this.user.enableRecordingHours]

        });
    }

}
